import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateShopperPopupKicker: {
    defaultMessage: 'Want to rate shop fast?',
    id: '0vlZk9',
    description: 'Kicker text above the headline on the rate shopper automation popup',
  },
  rateShopperPopupHeadline: {
    defaultMessage: 'Use an automation rule!',
    id: 'dLZetI',
    description: 'Headline on the rate shopper automation popup',
  },
  rateShopperPopupBody: {
    defaultMessage: 'Add our default automation rule to automatically configure the lowest rate for your shipments.',
    id: 'aXOZbD',
    description: 'Body copy on the rate shopper automation popup; the link opens the rule editor via the Add rule button',
  },
  rateShopperPopupAddRuleButton: {
    defaultMessage: 'Add rule',
    id: '9qltzB',
    description: 'Primary button on the rate shopper automation popup that opens the rule editor',
  },
  rateShopperPopupSnoozeButton: {
    defaultMessage: 'Snooze',
    id: 'c91YSv',
    description: 'Text button on the rate shopper automation popup that dismisses the popup for 24 hours',
  },
});
